import script from "./Work.vue?vue&type=script&setup=true&lang=js"
export * from "./Work.vue?vue&type=script&setup=true&lang=js"

import "./style.scss?vue&type=style&index=0&id=1093e602&lang=scss&scoped=true"

import exportComponent from "/Users/kobayashiyasutaka/Documents/Projects/murakihp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1093e602"]])

export default __exports__